import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material';

const styles = makeStyles(() => ({
	boxClass: {
		position: 'absolute' as 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: 380,
		backgroundColor: useTheme().palette.background.paper,
		borderRadius: useTheme().spacing(2.5),
		padding: useTheme().spacing(2),
	},

	containerRoot: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	textInputContainer: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		width: '100%',
	},
	gridClass: {
		paddingLeft: useTheme().spacing(2),
		paddingRight: useTheme().spacing(2),
	},
	customBtnClass: {
		marginTop: useTheme().spacing(2),
	},
	closeIconClass: {
		top: 10,
		right: 10,
		position: 'absolute',
		borderRadius: 10,
		cursor: 'pointer',
	},
}));

export default styles;
